import React from 'react';
import Header from './Header';
import Hero from './Hero';
import Services from './Services';
import NimbleSystem from './NimbleSystem';
import Benefits from './Benefits';
import HowItWorks from './HowItWorks';
import WhyWereDifferent from './WhyWereDifferent';
import Pricing from './Pricing';
import Testimonials from './Testimonials';
import CaseStudies from './CaseStudies';
import FAQ from './FAQ';
import ContactForm from './ContactForm';
import Footer from './Footer';

const LandingPage = () => {
  return (
    <div className="bg-white text-gray-900 min-h-screen">
      <Header />
      <main>
        <Hero />
        <Services />
        <NimbleSystem />
        <Benefits />
        <HowItWorks />
        <WhyWereDifferent />
        <Pricing />
        <Testimonials />
        <CaseStudies />
        <FAQ />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
